import { z } from "zod";

// Time format validation (HH:MM)
const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;

export const addEventSchema = z.object({
  title: z
    .string()
    .min(3, "O título deve ter no mínimo 3 caracteres")
    .max(100, "O título deve ter no máximo 100 caracteres"),
  description: z
    .string()
    .min(10, "A descrição deve ter no mínimo 10 caracteres")
    .max(500, "A descrição deve ter no máximo 500 caracteres"),
  date: z.date({
    required_error: "A data é obrigatória",
    invalid_type_error: "Data inválida",
  }),
  startTime: z
    .string()
    .regex(timeRegex, "Formato inválido. Use HH:MM (ex: 14:30)"),
  endDate: z.date({
    required_error: "A data de término é obrigatória",
    invalid_type_error: "Data inválida",
  }),
  endTime: z
    .string()
    .regex(timeRegex, "Formato inválido. Use HH:MM (ex: 16:00)"),
  ordemDoDia: z.instanceof(File).optional(),
  analiseTecnica: z.instanceof(File).optional(),
  outrosAnexos: z.instanceof(File).optional(),
}).refine(
  (data) => {
    // Validate that endDate is >= startDate
    const startDate = new Date(data.date);
    const endDate = new Date(data.endDate);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    return endDate >= startDate;
  },
  {
    message: "A data de término deve ser posterior ou igual à data de início",
    path: ["endDate"],
  }
).refine(
  (data) => {
    // If same day, validate that endTime is after startTime
    const startDate = new Date(data.date);
    const endDate = new Date(data.endDate);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    if (startDate.getTime() === endDate.getTime()) {
      const [startHour, startMin] = data.startTime.split(":").map(Number);
      const [endHour, endMin] = data.endTime.split(":").map(Number);
      const startMinutes = startHour * 60 + startMin;
      const endMinutes = endHour * 60 + endMin;
      return endMinutes > startMinutes;
    }

    return true;
  },
  {
    message: "O horário de término deve ser posterior ao horário de início",
    path: ["endTime"],
  }
);

export type AddEventFormData = z.infer<typeof addEventSchema>;
